import axios from 'axios';

import config from '../config';
import BusinessUnit from '../interfaces/BusinessUnit';
import { ProductCombination } from '../interfaces/ProductCombination';

const { apiServerUrl } = config;

interface GetProductHierarchyValuesParams {
  hierarchies: string[];
  businessUnits: BusinessUnit[];
  abortController?: AbortController;
  limit?: number;
  query?: string;
  isHierarchyRestrictionEnabled?: boolean
}

export const getProductHierarchyValues = async ({
  hierarchies,
  businessUnits,
  abortController,
  limit,
  query,
  isHierarchyRestrictionEnabled = false
}: GetProductHierarchyValuesParams) => {
  return axios
    .post<ProductCombination[]>(
      `${apiServerUrl}/users/product/hierarchy-value`,
      {
        hierarchies,
        businessUnits,
        limit,
        query,
        isHierarchyRestrictionEnabled
      },
      {
        signal: abortController?.signal,
      }
    )
    .then(({ data }) => data);
};